import { Nullable } from '@kts-front/types';

import { RoomsAmount } from 'entities/Lot/Room';
import { SortDirection } from 'entities/Lot/Sort';
import { LotApartmentLayoutType } from 'entities/Lot/types';
import { FieldSelectPlaceTypeMultiStore } from 'stores/local/shared/FieldSelectPlaceTypeStore';
import { FieldSelectProjectMultiStore } from 'stores/local/shared/FieldSelectProjectStore';
import { FieldCheckedStore } from 'stores/local/shared/form/FieldCheckedStore';
import { FieldDateStore } from 'stores/local/shared/form/FieldDateStore';
import { FieldNumberStore } from 'stores/local/shared/form/FieldNumberStore';
import { FieldSelectMultiStore, FieldSelectStore } from 'stores/local/shared/form/FieldSelectStore';

export enum FieldName {
  projects = 'project_id__in',
  places = 'place_type_id',
  keysHandoverAt = 'keys_handover_at__le',
  rooms = 'rooms',
  priceFrom = 'price__ge',
  priceTo = 'price__le',
  promotion = 'promotion',
  orderBy = 'order_by',
  orderByDirection = 'order_by_direction',
  section = 'section_id',
  areaFrom = 'area__ge',
  areaTo = 'area__le',
  floorFrom = 'floor__ge',
  floorTo = 'floor__le',
  windowView = 'window_view_id',
  decoration = 'apartment_decoration_id',
  reserved = 'reserved',
  layoutType = 'layout_type__in',
  apartmentSection = 'apartment_section__in',
}

export type FieldsMap = {
  [FieldName.projects]: FieldSelectProjectMultiStore;
  [FieldName.places]: FieldSelectPlaceTypeMultiStore;
  [FieldName.keysHandoverAt]: FieldDateStore;
  [FieldName.rooms]: FieldSelectMultiStore;
  [FieldName.priceFrom]: FieldNumberStore;
  [FieldName.priceTo]: FieldNumberStore;
  [FieldName.promotion]: FieldCheckedStore;
  [FieldName.orderBy]: FieldSelectStore;
  [FieldName.orderByDirection]: FieldCheckedStore;
  [FieldName.section]: FieldSelectMultiStore;
  [FieldName.areaFrom]: FieldNumberStore;
  [FieldName.areaTo]: FieldNumberStore;
  [FieldName.floorFrom]: FieldNumberStore;
  [FieldName.floorTo]: FieldNumberStore;
  [FieldName.windowView]: FieldSelectMultiStore;
  [FieldName.decoration]: FieldSelectMultiStore;
  [FieldName.reserved]: FieldSelectMultiStore;
  [FieldName.layoutType]: FieldSelectMultiStore;
  [FieldName.apartmentSection]: FieldSelectMultiStore;
};

export type FilterServerFormat = {
  [FieldName.projects]: number[];
  [FieldName.places]: number[];
  [FieldName.keysHandoverAt]: Nullable<string>;
  [FieldName.rooms]: Nullable<RoomsAmount[]>;
  [FieldName.priceFrom]: Nullable<number>;
  [FieldName.priceTo]: Nullable<number>;
  [FieldName.promotion]: Nullable<boolean>;
  [FieldName.orderBy]: Nullable<string>;
  [FieldName.orderByDirection]: Nullable<SortDirection>;
  [FieldName.section]: number[];
  [FieldName.areaFrom]: Nullable<number>;
  [FieldName.areaTo]: Nullable<number>;
  [FieldName.floorFrom]: Nullable<number>;
  [FieldName.floorTo]: Nullable<number>;
  [FieldName.windowView]: number[];
  [FieldName.decoration]: number[];
  [FieldName.reserved]: Nullable<boolean>;
  [FieldName.layoutType]: LotApartmentLayoutType[];
  [FieldName.apartmentSection]: string[];
};

export interface MinMaxProps {
  priceMin: number;
  priceMax: number;
  areaMin: number;
  areaMax: number;
  floorMin: number;
  floorMax: number;
}

export type FilterQueryFormat = Omit<FilterServerFormat, FieldName.reserved> & {
  [FieldName.reserved]: string[];
};
